import { useCallback } from 'react'

const useScrolledToTop = (offset) => useCallback(node => {
  if (node !== null) {
    let scrollTop = node.offsetTop + offset
    window.scrollTo({
      top: scrollTop,
      // scroll instantly (instead of potentially smooth due to bootstrap)
      // to avoid race-conditions on repositioning
      behavior: 'instant',
    })
  }
}, [])

export default useScrolledToTop
